import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { isLoggedOnSelector } from './isLoggedOnSelector';

export const carVehicleTariffGroupSelector = selector<string>({
    key: 'carVehicleTariffGroupSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const currentProduct = get(getOnsaCurrentProductSelector);
        const isLoggedOn = get(isLoggedOnSelector);

        return await OnlineSalesUnauthenticated.getVehicleTariffGroup(
            jobNumber,
            sessionId,
            currentProduct.fixedId,
            !isLoggedOn
        );
    }
});
